import produce from 'immer';
import { create } from 'zustand';

const MAX_UPLOAD_SIZE_FREE = 10 * 1024 * 1024;
const MAX_UPLOAD_SIZE_NON_MULTIPART = 4.9 * 1024 * 1024 * 1024;
const getPathFromFile = (file) => {
  const path = file.webkitRelativePath;
  return path.replace(file.name, "");
};
const useFileUploadStore = create()((set, get) => ({
  files: [],
  tooDeep: false,
  tooBigFiles: 0,
  setTooDeep: (tooDeep) => set({
    tooDeep
  }),
  addFile: (file, path) => {
    const newFile = {
      file,
      metadata: {
        path: path || getPathFromFile(file)
      }
    };
    const newState = produce(get(), (draft) => {
      draft.files.push(newFile);
    });
    set(newState);
    return newFile;
  },
  addFiles: (files) => {
    const newState = produce(get(), (draft) => {
      draft.files.push(...files.map((f) => ({
        file: f.file,
        metadata: {
          path: f.path || getPathFromFile(f.file)
        }
      })));
    });
    set(newState);
  },
  setFiles: (files) => set({
    files
  }),
  incrementTooBigFiles: () => set((state) => ({
    tooBigFiles: state.tooBigFiles + 1
  })),
  clearFiles: () => set({
    files: [],
    tooDeep: false,
    tooBigFiles: 0
  })
}));

export { MAX_UPLOAD_SIZE_FREE, MAX_UPLOAD_SIZE_NON_MULTIPART, useFileUploadStore as default };
//# sourceMappingURL=fileUploadStore.js.map
